import { Assert } from '@team/assert';

type PreloadResourceOptions = {
  type?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
};

export function preloadResource(
  href: string,
  as: string,
  { type, fetchPriority }: PreloadResourceOptions = {}
): Promise<void> {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');

    link.addEventListener('load', () => {
      queueMicrotask(link.remove.bind(link));
      resolve();
    });

    link.addEventListener('error', (event) => {
      queueMicrotask(link.remove.bind(link));

      reject(
        new Error(`Failed to preload resource: ${href}`, { cause: event })
      );
    });

    link.rel = 'preload';
    link.href = href;
    link.as = as;

    if (Assert.isString(type)) {
      link.type = type;
    }

    if (Assert.isString(fetchPriority)) {
      link.fetchPriority = fetchPriority;
    }

    link.crossOrigin = 'anonymous';

    document.head.appendChild(link);
  });
}

export function preloadFont(
  href: string,
  type: string,
  options?: Omit<PreloadResourceOptions, 'type'>
) {
  return preloadResource(href, 'font', { type, ...options });
}
